import { useCallback } from 'react';

/**
 * Merges multiple refs into a single callback ref
 * Handles both callback refs and ref objects safely
 */
export function useRefMerger<T>(...refs: Array<React.Ref<T> | undefined>) {
  return useCallback(
    (node: T | null) => {
      refs.forEach(ref => {
        if (ref) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            // MutableRefObject
            (ref as React.MutableRefObject<T | null>).current = node;
          }
        }
      });
    },
    refs // eslint-disable-line react-hooks/exhaustive-deps
  );
}

/**
 * Type-safe ref merger for HTMLInputElement specifically
 */
export function useInputRefMerger(
  ...refs: Array<React.Ref<HTMLInputElement> | undefined>
) {
  return useRefMerger<HTMLInputElement>(...refs);
}
